import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { bankUsersReportQueryOptions } from '~bank-reports/service/bankUsersReportQueryOptions'
import { BankUsersReportFilterParams, bankUsersReportFilterParamsSchema } from '~bank-reports/types/BankUsersReport'

import { UserReportContext } from './UserReportContext'

type UserReportProviderProps = {
  children: ReactNode
}

export const UserReportContextProvider: FC<UserReportProviderProps> = ({ children }) => {
  const routeApi = getRouteApi('/_app/reports/user')
  const search = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const userReportQuery = useQuery(bankUsersReportQueryOptions(search))

  if (!userReportQuery.data) return null

  const value = {
    data: userReportQuery.data,
    isPending: userReportQuery.isLoading || userReportQuery.isRefetching,
    successFullyLoaded: !!userReportQuery.data,
    state: { ...search, ...userReportQuery.data.form },
    navigate: (searchParams: Partial<BankUsersReportFilterParams>) =>
      navigate({ to: '.', search: (prev: any) => ({ ...prev, ...searchParams }), resetScroll: false, replace: true }),
    clear: () =>
      navigate({ to: '.', search: bankUsersReportFilterParamsSchema.parse({}), resetScroll: false, replace: true })
  }

  return <UserReportContext.Provider value={value}>{children}</UserReportContext.Provider>
}
